module.exports = __webpack_public_path__ + "static/media/Portrait-10032.434b1aee.jpg";